import React from 'react';
import '../../styles/SettingsSidebar.css';
import { useAuth } from '../../context/AuthContext';

export default function SettingsSidebar({ activeSection, onSectionChange }) {
  const { logout } = useAuth();

  const sections = [
    { id: 'personal-info', label: 'PERSONAL INFO' },
    { id: 'password', label: 'PASSWORD MANAGEMENT' },
    { id: 'payment', label: 'PAYMENT & SUBSCRIPTIONS' },
    { id: 'guide', label: 'USER GUIDE & TRAINING' },
  ];

  return (
    <aside className="rv-sidebar-settings">
      <nav className="rv-sidebar-settings__nav" aria-label="Settings navigation">
        {sections.map((section) => (
          <button
            key={section.id}
            className={`rv-sidebar-settings__button ${
              activeSection === section.id
                ? 'rv-sidebar-settings__button--primary'
                : 'rv-sidebar-settings__button--secondary'
            }`}
            onClick={() => onSectionChange(section.id)}
          >
            {section.label}
          </button>
        ))}
      </nav>

      <div className="rv-sidebar-settings__footer">
        <button
          className="rv-sidebar-settings__logout"
          onClick={logout}
        >
          LOG OUT
        </button>
      </div>
    </aside>
  );
}